module.exports = __webpack_public_path__ + "static/media/may.862c9073.jpeg";